import { render, staticRenderFns } from "./VuesticFileUpload.vue?vue&type=template&id=2c4d6fe8&"
import script from "./VuesticFileUpload.vue?vue&type=script&lang=js&"
export * from "./VuesticFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./VuesticFileUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports